(function () {
  const sectionElement = document.currentScript.closest('.section');

  if (!sectionElement || !window.Shopify) return;

  const toggleElement = sectionElement.querySelector('[data-privacy-choices-toggle]');
  const statusElement = sectionElement.querySelector('[data-privacy-choices-status]');

  if (!toggleElement) return;

  const declinedConsent = {
    marketing: false,
    analytics: false,
    preferences: false,
    sale_of_data: false,
  };

  const acceptedConsent = {
    marketing: true,
    analytics: true,
    preferences: true,
    sale_of_data: true,
  };

  function applyConsentState(isSaleOfDataAllowed) {
    const isOptedOut = isSaleOfDataAllowed === false;

    toggleElement.checked = isOptedOut;

    if (statusElement) {
      statusElement.classList.toggle('privacy-choices__form-status--visible', isOptedOut);
    }
  }

  function handleConsentCollected(consentEvent) {
    applyConsentState(consentEvent.detail.saleOfDataAllowed);
  }

  function updateTrackingConsent(isOptedOut) {
    const consent = isOptedOut ? declinedConsent : acceptedConsent;

    window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {
      applyConsentState(window.Shopify.customerPrivacy.saleOfDataAllowed());
    });
  }

  function handleToggleChange(changeEvent) {
    updateTrackingConsent(changeEvent.target.checked);
  }

  function initPrivacyChoices() {
    applyConsentState(window.Shopify.customerPrivacy.saleOfDataAllowed());
    toggleElement.addEventListener('change', handleToggleChange);
  }

  document.addEventListener('visitorConsentCollected', handleConsentCollected);

  if (window.Shopify.customerPrivacy) {
    initPrivacyChoices();
    return;
  }

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (loadError) {
    if (loadError) return;

    initPrivacyChoices();
  });
})();
